"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.request = void 0;
const function_1 = require("fp-ts/lib/function");
const Model = __importStar(require("../model"));
const TE = __importStar(require("fp-ts/TaskEither"));
const Err = __importStar(require("@fixtuur/error-context"));
const requestError_1 = require("./requestError");
const request = (serviceUrl) => (p) => {
    return (0, function_1.pipe)(TE.Do, TE.bind('modelId', () => TE.right(Model.getModelId(p.productId, p.articleType))), TE.bind('deleteModelUrl', ({ modelId }) => TE.right(new URL(`${serviceUrl.pathname}/models/${modelId}`, serviceUrl).toString())), TE.bind('response', ({ deleteModelUrl }) => TE.tryCatch(() => fetch(deleteModelUrl, {
        method: 'DELETE',
    }), err => Err.construct(requestError_1.RequestError.FetchError, {
        error: err?.message,
        deleteModelUrl,
    }))), TE.chain(original => {
        const { response } = original;
        if (!response.ok) {
            return TE.left(Err.construct(requestError_1.RequestError.NoHttpSuccessCodeError, {
                responseUrl: response.url,
                responseStatus: response.status.toString(10),
                responseStatusText: response.statusText,
            }));
        }
        return TE.right(original);
    }), TE.map(_ => true));
};
exports.request = request;
